module.exports = __webpack_public_path__ + "media/step_2_ru.db50d829.mp3";